import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import MeetTheDonkey from "@/pages/MeetTheDonkey";
import ExampleVerdict from "@/pages/ExampleVerdict";
import DonkeyCheck from "@/pages/DonkeyCheck";
import Pricing from "@/pages/Pricing";
import Usage from "@/pages/Usage";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import EmailPreferences from "@/pages/EmailPreferences";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ResetPassword from "@/pages/ResetPassword";
import Interview from "@/pages/Interview";
import Review from "@/pages/Review";
import Analysis from "@/pages/Analysis";
import Report from "@/pages/Report";
import Validation from "@/pages/Validation";
import BuildStart from "@/pages/BuildStart";
import BuildWorkspace from "@/pages/BuildWorkspace";
import LaunchWorkspace from "@/pages/LaunchWorkspace";
import GrowWorkspace from "@/pages/GrowWorkspace";
import TeamManagement from "@/pages/TeamManagement";
import InvitationAccept from "@/pages/InvitationAccept";
import BrandRep from "@/pages/BrandRep";
import GrowthExperiments from "@/pages/GrowthExperiments";
import ContactPage from "@/pages/ContactPage";
import SupportCentre from "@/pages/SupportCentre";
import AdminSupport from "@/pages/AdminSupport";
import DonkeyBot from "@/pages/DonkeyBot";
import BuildPreview from "@/pages/BuildPreview";
import PublicSite from "@/pages/PublicSite";
import Dashboard from "@/pages/Dashboard";
import Workspace from "@/pages/Workspace";
import ProveComplete from "@/pages/ProveComplete";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Demo from "@/pages/Demo";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import RouteSeo from "@/components/RouteSeo";
import ViabilityCalculator from "@/pages/ViabilityCalculator";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <RouteSeo />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/meet-the-donkey" element={<MeetTheDonkey />} />
            <Route path="/example" element={<MeetTheDonkey />} />
            <Route path="/example/:id" element={<ExampleVerdict />} />
            <Route path="/donkey-check" element={<DonkeyCheck />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/viability-calculator" element={<ViabilityCalculator />} />
            <Route path="/account" element={<ProtectedRoute><Usage /></ProtectedRoute>} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/donkeybot" element={<DonkeyBot />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="/cookies" element={<Legal kind="cookies" />} />
            <Route path="/accessibility" element={<Legal kind="accessibility" />} />
            <Route path="/email-preferences" element={<EmailPreferences />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/workspace/:id" element={<ProtectedRoute><Workspace /></ProtectedRoute>} />
            <Route path="/prove-complete/:id" element={<ProtectedRoute><ProveComplete /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            <Route path="/validate/:reportId" element={<ProtectedRoute><Validation /></ProtectedRoute>} />
            <Route path="/build/start/:reportId/:oppIndex" element={<ProtectedRoute><BuildStart /></ProtectedRoute>} />
            <Route path="/build/:bid" element={<ProtectedRoute><BuildWorkspace /></ProtectedRoute>} />
            <Route path="/launch/:bid" element={<ProtectedRoute><LaunchWorkspace /></ProtectedRoute>} />
            <Route path="/grow/:bid" element={<ProtectedRoute><GrowWorkspace /></ProtectedRoute>} />
            <Route path="/businesses" element={<ProtectedRoute><TeamManagement /></ProtectedRoute>} />
            <Route path="/join" element={<InvitationAccept />} />
            <Route path="/brandrep/:bid" element={<ProtectedRoute><BrandRep /></ProtectedRoute>} />
            <Route path="/growth/:bid" element={<ProtectedRoute><GrowthExperiments /></ProtectedRoute>} />
            <Route path="/support" element={<ProtectedRoute><SupportCentre /></ProtectedRoute>} />
            <Route path="/admin/support" element={<ProtectedRoute><AdminSupport /></ProtectedRoute>} />
            <Route path="/build/:bid/preview" element={<ProtectedRoute><BuildPreview /></ProtectedRoute>} />
          </Route>

          {/* Full-bleed routes (no default layout) */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/interview" element={<Interview />} />
          <Route path="/interview/:id" element={<Interview />} />
          <Route path="/review/:id" element={<Review />} />
          <Route path="/analysis/:id" element={<Analysis />} />
          <Route path="/report/:id" element={<Report />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/site/:slug" element={<PublicSite />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" />
    </AuthProvider>
  );
}

export default App;
